import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { OrderInfoTab, OrderInfoTabs, OrderInfoTabText } from './index.styled'

const ProcessingTimeOrderTabs = React.memo(({ currentTab, onClickTab }) => {
	const { t } = useTranslation()
	const tabs = useMemo(() => [
		{ value: 'MAP', label: t('Modal.processingTimeOrderModal.tabs.showMap') },
		{ value: 'ORDER', label: t('Modal.processingTimeOrderModal.tabs.showOrder') }
	], [t])


	return (
		<OrderInfoTabs>
			{tabs?.map((tab, index) =>
				<OrderInfoTab key={index}
											className={tab.value === currentTab ? 'active' : ''}
											onClick={() => onClickTab(tab.value)}>
					<OrderInfoTabText className={tab.value === currentTab ? 'active' : ''}>
						{tab.label}
					</OrderInfoTabText>
				</OrderInfoTab>)}
		</OrderInfoTabs>
	)
})

ProcessingTimeOrderTabs.displayName = 'ProcessingTimeOrderTabs'
export default ProcessingTimeOrderTabs
